export default "__VITE_ASSET__C5h8TWBN__"